export default __webpack_public_path__ + "static/media/premium2.7f5ecb02.webp";